<template>
	<div>
		<span class="m-0" id="cart"></span>
		<div v-if="is_load" class="w-100 py-4 text-center">
      <loader />
    </div>
    <template v-else>
    	<div class="px-4" v-if="error != ''">
      	<ErrorMessage :message="error" />
    	</div>
      <template v-else>
      	<warning-box 
      		v-if="getVoucherOrder.cart.length == 0"
      		:title="$t('hotel.concierge.fitur.empty-cart')"
      		:body="$t('hotel.concierge.fitur.you-havent-selected-any-vouchers-yet')"
      		:btn_primary="$t('hotel.concierge.fitur.browse-voucher')"
      		@yes="goBack">
      	</warning-box>

      	<template v-else>
	      	<!-- HEADER -->
					<wrapper-mobile-view>
						<div class="w-100 bg-white py-3 px-4 border-b-semi-grey">
							<div class="w-100">
								<div class="row">
									<div class="col-1 align-self-center">
										<router-link :to="`/${getMerchant.code}/upselling/${getVoucherGroupId}`" class="d-inline-grid">
	                    <img src="../../../assets/img/icon/back.png" class="mt-1" width="20">
	                  </router-link>
									</div>
									<div class="col-10 align-self-center">
										<p class="mb-0 body-1-2">{{$t('hotel.concierge.fitur.order-summary')}}</p>
									</div>
								</div>
							</div>
						</div>
					</wrapper-mobile-view>
					<block :height="57" />

					<template v-if="cart_step == 1">
						<!-- VOUCHER LIST -->
						<div class="px-4 border-b-semi-grey">
							<p class="mb-0 heading-6-1">{{$t('restaurant.your-order')}}</p>
							<div class="w-100">
								<div v-for="cart,index_cart in getVoucherOrder.cart" class="w-100" :class="index_cart+1 < getVoucherOrder.cart.length ? 'mb-3' : ''">
									<div v-for="(product,index_product) in cart.product" :class="index_product+1 < cart.product.length ? 'mb-3 border-b-semi-grey' : ''">
										<VoucherItemCart :product="product" :index_product="index_product"></VoucherItemCart>
									</div>
								</div>
							</div>
						</div>
						<div class="px-4 py-4 w-100 border-b-semi-grey">
							<div class="w-100">
								<div class="row">
									<div class="col-9 align-self-center">
										<p class="mb-0 body-1-2">{{$t('hotel.concierge.fitur.more-voucher')}}</p>
										<p class="mb-0 body-2-2-1">{{$t('hotel.concierge.fitur.yup-i-want')}}</p>
									</div>
									<div class="col-3 align-self-center">
										<button
											@click="$router.push(`/${getMerchant.code}/upselling/${getVoucherGroupId}`)" 
											class="ga-btn-primary-outline">
											{{$t('hotel.action.add')}}
										</button>
									</div>
								</div>
							</div>
						</div>

						<!-- NOTE -->
						<div class="px-4 py-4 w-100 border-b-semi-grey" id="note_section">
							<p class="mb-3 heading-6-1">{{$t('hotel.concierge.add-note')}}</p>
							<div class="w-100 position-relative">
								<textarea
									rows="1"
									:placeholder="$t('hotel.concierge.fitur.cart.placeholder-note')"
									class="body-2-2 pl-5 pr-3 w-100 border-semi-grey radius-12" 
									style="padding-top:12px;padding-bottom:12px;"
									v-model="notes">
								</textarea>
								<img src="../../../assets/img/icon/notes.svg" height="14" class="position-absolute" style="left:20px;top:15px;">
							</div>
						</div>

						<!-- CUSTOMER DETAIL -->
						<div class="px-4 py-4 w-100 border-b-semi-grey">
							<p class="mb-0 heading-6-1">{{$t('restaurant.contact-detail')}}</p>
							<p class="mb-2 body-2-2-1">{{$t('hotel.concierge.fitur.voucher-detail-ordered')}}</p>
							<div class="w-100 mb-3">
								<label for="form_name" class="body-3-1 mb-1 w-100">{{$t('general.your-name')}}</label>
								<input 
									id="form_name" 
									:placeholder="$t('hotel.concierge.fitur.cart.placeholder-name')" 
									type="text" 
									class="border-semi-grey radius-12 body-2-1 w-100 mb-1"
									:class="{'border-danger':form_validation.name != ''}"
									style="padding: 12px 14px;"
									v-model="customer_detail.first_name" />
									<p v-if="form_validation.name != ''" class="mb-0 body-3-3-1 text-danger"><i class="simple-icon-exclamation mr-1"></i> {{form_validation.name}}</p>
							</div>
							<div class="w-100 mb-3">
								<label for="form_email" class="body-3-1 mb-1 w-100">{{$t('hotel.concierge.fitur.cart.email-address')}}</label>
								<input 
									:placeholder="$t('hotel.concierge.fitur.cart.placeholder-email')" 
									id="form_email" 
									type="text" 
									class="border-semi-grey radius-12 body-2-1 w-100 mb-1"
									:class="{'border-danger':form_validation.email != ''}"
									style="padding: 12px 14px;"
									v-model="customer_detail.email" />
									<p v-if="form_validation.email != ''" class="mb-0 body-3-3-1 text-danger"><i class="simple-icon-exclamation mr-1"></i> {{form_validation.email}}</p>
							</div>
							<div class="w-100">
								<label for="form_phone" class="body-3-1 mb-1 w-100">{{$t('hotel.concierge.form.phone-number')}}</label>
								<input 
									id="form_phone" 
									type="text" 
									class="border-semi-grey radius-12 body-2-1 w-100 mb-1"
									style="padding: 12px 14px;"
									:placeholder="$t('hotel.concierge.fitur.cart.placeholder-phone-number')" 
									:class="{'border-danger':form_validation.phone_number != ''}"
									v-model="customer_detail.phone_number" />
								<p v-if="form_validation.phone_number != ''" class="mb-0 body-3-3-1 text-danger"><i class="simple-icon-exclamation mr-1"></i> {{form_validation.phone_number}}</p>
							</div>
						</div>

						<!-- PROMO CODE -->
						<div class="px-4 py-4 w-100 border-b-semi-grey" id="promo_section">
							<VoucherPromoCode></VoucherPromoCode>
						</div>

						<!-- PAYMENT OPTION -->
            <template v-if="general_data.payment_mode == 'PAY_IMMEDIATELY_OR_LATER'">
              <div class="mt-4 px-4" :class="payment_mode_valid != '' ? 'border-danger' : ''">
                <PaymentOption @getSelectedOption="getPaymentOptionSelected"></PaymentOption>
              </div>  
              <p v-if="payment_mode_valid != ''" class="mb-0 body-3-3-1 text-danger">{{payment_mode_valid}}</p>
              <div class="w-100 border-semi-grey my-4"></div>
            </template>
					</template>

					<template v-else>
						<!-- PAYMENT METHODS -->
						<div class="px-4 pb-4 w-100 border-b-semi-grey">
							<p class="mb-0 heading-6-1">Choose payment method</p>
              <p class="mb-3 body-2-2-1">All transaction are secured and encrypted</p>
							<div class="w-100">
								<!-- <template v-if="payment_method.selected.id">
									<div class="w-100 mb-3 radius-12 p-3 cursor-pointer border-green">
										<div class="row no-gutters">
											<div class="col-10">
												<p class="mb-0 body-2-1 text-green">{{payment_method.selected.name}}</p>
												<div class="body-3-3-1 html-desc" v-html="payment_method.selected.description"></div>
											</div>
											<div class="col-2 text-right">
												<i @click="payment_method.selected = {}" class="simple-icon-close text-24 text-danger cursor-pointer"></i>
											</div>
										</div>
									</div>
									<div class="w-100 border-t-semi-grey mb-2 py-3">
										<p class="body-3-3 mb-0">{{$t('hotel.concierge.fitur.payment-method-list')}}</p>
									</div>
								</template> -->
								<template v-for="(pm,index) in payment_method.list">

									<div v-if="index < payment_method.show_list" class="w-100 mb-3 radius-12 p-3 cursor-pointer" :class="pm.id == payment_method.selected.id ? 'border-green' : 'border-semi-grey'" @click="payment_method.selected = pm">
										<div class="row no-gutters">
											<div class="col-1">
												<div class="dimention-24 rounded-circle" :class="pm.id == payment_method.selected.id ? 'custom-radio-active' : 'border-semi-grey-3'">
												</div>
											</div>
											<div class="col-9">
												<div class="px-2">
													<p class="mb-0 body-2-1" :class="{'text-green': pm.id == payment_method.selected.id}">{{pm.name}}</p>
													<span v-if="pm.bank_name == 'DIRECT_PAYMENT' || (pm.bank_name == 'WISE' && pm.payment_method == 'BANK_TRANSFER')" class="body-3-3-2 mb-0 text-orange d-block">{{$t('general.manually-checked')}}</span>
													<span v-else class="body-3-3-2 mb-0 text-green d-block">{{$t('general.checked-automatically')}}</span>
													<div class="body-3-3-1 html-desc" :class="{'text-truncate-2' : pm.id != payment_method.selected.id}" v-html="pm.description"></div>
												</div>
											</div>
											<div class="col-2">
												<img :src="pm.image_url" style="width: 100%; object-fit:contain;">
											</div>
										</div>
									</div>
								</template>
								<p 
									v-if="payment_method.show_list < payment_method.list.length" 
									@click="payment_method.show_list = payment_method.list.length"
									class="mb-0 body-3-1 text-green w-100 text-center cursor-pointer underline text-14 pt-2">{{$t('hotel.concierge.fitur.show-all-payment-method')}}</p>
							</div>
						</div>
					</template>

					<!-- PRICE DETAIL -->
					<div class="px-4 py-4 w-100">
						<p class="mb-3 heading-6-1">{{$t('hotel.concierge.price-detail')}}</p>
						<div class="p-3 border-green rounded-6 position-relative">
              <div class="w-100 z-index-1029 position-relative">
                <div class="row mb-2 pb-1">
                  <div class="col-6">
                    <p class="mb-0 body-2-2 font-semibold">{{$t('hotel.concierge.sub-total')}}</p>
                  </div>
                  <div class="col-6 text-right">
                    <p class="mb-0 body-2-2 font-semibold">{{$formatCurrency(getVoucherOrderSubTotal)}}</p>
                  </div>
                </div>
								<div class="row mb-2 pb-1">
                  <div class="col-6">
                    <p class="mb-0 body-2-2 font-semibold">{{$t('hotel.concierge.discount')}} <span v-if="getDiscountPercent>0">(-{{getDiscountPercent}}%)</span></p>
                  </div>
                  <div class="col-6 text-right">
                    <p class="mb-0 body-2-2 font-semibold">{{$formatCurrency(getDiscountPercent)}}</p>
                  </div>
                </div>
                <div class="row mb-2 pb-1" v-if="getPaymentSurcharge > 0">
                  <div class="col-6">
                    <p class="mb-0 body-2-2 font-semibold">{{$t('hotel.payment-surcharge')}}</p>
                  </div>
                  <div class="col-6 text-right">
                    <p class="mb-0 body-2-2 font-semibold">{{$formatCurrency(getPaymentSurcharge)}}</p>
                  </div>
                </div>
                <div class="border-top">
                  <div class="row pt-2">
                    <div class="col-6">
                      <p class="mb-0 body-1-2 font-bold">{{$t('hotel.concierge.total')}}</p>
                    </div>
                    <div class="col-6 text-right">
                      <p class="mb-0 body-1-2 font-bold">{{$formatCurrency(getVoucherOrderTotal+getPaymentSurcharge)}}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="z-index-1028 position-absolute w-100 h-100 bg-green radius-12" style="top:0;left:0;opacity:0.04"></div>
            </div>
					</div>

					<!-- SUBMIT AREA -->
          <ErrorMessage v-if="error_push != ''" :message="error_push" />
          <div class="container px-4 pt-4 mb-3 mt-2">
            <state-button 
              size="lg"
              variant="primary" 
              block 
              :click="submitForm">
              {{ btn_text }}
            </state-button>
          </div>

					<!-- XENDIT CC FORM -->
					<popup-detail 
			    	direction="bottom" 
			    	:show="show_xendit_form"
			    	wrapper_size="full"
			    	:no_close_backdrop="true"
			    	@close="toggleXenditForm">
			    	<template v-slot:body>
			    		<div class="p-5">
			    			<XenditInputCC
			    				v-if="show_xendit_form"
	                :tx_payment="result_tx_payment"
	                module_page="UPSELLING"
	                @done="resetCart"
	                @expired="toggleXenditForm">
	              </XenditInputCC>
			    		</div>
			    	</template>
			    </popup-detail>
				</template>
			</template>
		</template>
	</div>
</template>
<script>
	import {mapGetters,mapMutations} from 'vuex'
	import {get,post} from '@/services/index.js'
	import config from '@/config/index.js';
	import VoucherItemCart from '@/components/hotel/upselling/VoucherItemCart'
	import VoucherPromoCode from '@/components/hotel/upselling/VoucherPromoCode'
	import XenditInputCC from '@/components/hotel/be/XenditInputCC';
	import PaymentOption from '@/components/hotel/concierge/transaction/PaymentOption'
	import { validationMixin } from "vuelidate";
  const { required, email } = require("vuelidate/lib/validators");

	export default{
		components:{
			VoucherItemCart,
			VoucherPromoCode,
			XenditInputCC,
			PaymentOption
		},
		data(){
			return{
				is_load: false,
				error: '',
				notes: '',
				general_data: '',
				payment_method:{
					list: [],
					selected: {},
					show_list: 3
				},
				customer_detail:{
          first_name: '',
          email: '',
          phone_number: ''
        },
        form_validation:{
          name: '',
          email: '',
          phone_number: ''
        },
        push_loader: false,
        error_push: '',
        show_xendit_form: false,
        result_tx_payment: {},
        reservation: {},
				cart_step: 1,
				payment_mode_selected: {},
				payment_mode_valid: '',
				tx_inquiry: {}
			}
		},
		mixins: [validationMixin],
    validations: {
      customer_detail:{
        first_name:{
          required
        },
        email:{
          required,
          email
        },
        phone_number:{
          required
        },
      }
    },
		computed:{
			...mapGetters([
				'getMerchant',
				'getVoucherOrder',
				'getVoucherGroupId',
				'getVoucherOrderTotal',
				'getVoucherOrderTotalPromo',
				'getVoucherOrderSubTotal',
				'getUpsellRef',
				'getConciergeReservation'
			]),
			getDiscountPercent(){
				if(this.getVoucherOrderTotalPromo > 0){
					let res = (this.getVoucherOrderTotalPromo/this.getVoucherOrderTotal)*100
					return res.toFixed(1)
				}
				return 0
			},
			getPaymentSurcharge(){
				let total = 0

				if(this.payment_method.selected.id){
					if(this.payment_method.selected.surcharge_type == 'PERCENT'){
						total = (this.getVoucherOrderTotal/100)*this.payment_method.selected.surcharge_value
					}else{
						total = this.payment_method.selected.surcharge_value
					}
				}

				return total
			},
			is_credit_card(){
				if(this.payment_method.selected.id && this.payment_method.selected.payment_method == 'CREDIT_CARD'){
					return true
				}
				return false
			},
			need_payment(){
        let general_loaded = this.general_data.id
        let default_payment_now = this.general_data.payment_mode == 'PAY_IMMEDIATELY'
        let selected_paymnet_now = this.general_data.payment_mode == 'PAY_IMMEDIATELY_OR_LATER' && this.payment_mode_selected.id == 'PAY_IMMEDIATELY' 

        return general_loaded && (default_payment_now || selected_paymnet_now)
      },
      btn_text(){
        let text = 'Book Now'
        if(this.need_payment && this.cart_step == 1){
          text = 'Continue to payment'
        }
        return text
      },
		},
		mounted(){
			this.$smoothScroll('cart')
			this.loadFirstData()
		},
		methods:{
			...mapMutations(['resetVoucherOrder','setUpsellRef']),
			loadGeneralSetting(){
        this.is_load = true
        this.error = ''
        this.general_data = {}

        get("CORE_HOTEL","merchant-pos/concierge-voucher/general",{
          merchant_id: this.getMerchant.id
        }).then(response=>{
          let res = response.data
          if(res.success){
            this.general_data = res.data
          }else{
            this.error = res.message
          }
          this.is_load = false
        })
      },
			loadPaymentList(){
				return new Promise((success,fail)=>{
          const apiEndPoint = `merchant/${this.getMerchant.code}/payment-method`
					get('CORE_HOTEL', apiEndPoint, {
            module: 'concierge',
            module_code: 'concierge-voucher'
          }).then(response=>{
						let res = response.data
						if(res.success){
              const paymentMethodList = res.data.map(payment => {
                const { channel, pg_company } = payment;
                payment.payment_method = payment.channel
                payment.payment_channel = payment.channel
                payment.bank_name = payment.pg_company
                return payment;
              })
							success(paymentMethodList)
						}else{
							fail(res.message)
						}
					})
				})
			},
			loadReservationDetail(){
				return new Promise((success,fail)=>{
					get("CONCIERGE",`reservation/${this.getUpsellRef.reservation_id}`,{
						merchant_id: this.getMerchant.id
					}).then(response=>{
						if(response.data.success){
							success(response.data.data)
						}else{
							fail(response.data.message)
						}
					})
				})
			},
			loadFirstData(){
				this.is_load = true
				this.error = ''
				let func_exc = this.getUpsellRef.reservation_id != '' ? 
												[this.loadGeneralSetting(),this.loadReservationDetail()] : 
												[this.loadGeneralSetting()]
				Promise.all(func_exc).then(res=>{
					this.payment_method.selected = {}
					if(this.getUpsellRef.reservation_id != ''){
						this.reservation = res[1]
						this.customer_detail={
		          first_name: this.reservation.booked_by.name,
		          email: this.reservation.booked_by.email,
		          phone_number: this.reservation.booked_by.phone
		        }
					}else if(this.getConciergeReservation.guest_profile.id){
						this.customer_detail={
		          first_name: this.getConciergeReservation.guest_profile.name,
		          email: this.getConciergeReservation.guest_profile.email,
		          phone_number: this.getConciergeReservation.guest_profile.phone
		        }
					}
				}).catch(err=>{
					this.error = err
				}).finally(()=>{
					this.is_load = false
				})
			},
			changeCartStep(step){
        this.cart_step = step
        this.$smoothScroll('cart')
        if(this.cart_step == 2){
          this.loadPaymentList().then(res=>{
						let is_pg_jokul_cc_exist = res.some(x=>x.bank_name == 'JOKUL_DOKU' && x.payment_method == 'CREDIT_CARD')
            if(is_pg_jokul_cc_exist) this.$appendJokulScript()
            res.forEach(pm => {
              let is_payment_avlb = this.$conciergeAvlbPayment.some(x=>x.bank_name == pm.bank_name && x.payment_method.some(y=>y == pm.payment_method))
              
              if(is_payment_avlb) this.payment_method.list.push(pm)
            });
					})
        }
      },
			getPaymentOptionSelected(data){
        this.payment_mode_selected = data == null ? {} : data
      },
			scrollTo(id){
        document.getElementById(id).scrollIntoView({
          behavior: 'smooth'
        });
      },
      goBack(){
      	this.$router.push(`/${this.getMerchant.code}/upselling/${this.getVoucherGroupId}`)
      },
      toggleXenditForm(){
      	this.show_xendit_form = !this.show_xendit_form
      	if(!this.show_xendit_form){
      		this.result_tx_payment = {}
      	}
      },
      resetCart(){
      	this.resetVoucherOrder()
      },
      validateForm(){
				this.payment_mode_valid = ''
        this.form_validation = {
          name: false,
          email: false,
          phone_number: false
        }
        if(this.$v.customer_detail.first_name.$invalid){
          this.form_validation.name = 'Please input your name'
          this.scrollTo('note_section')
        }
        if(this.$v.customer_detail.email.$invalid){
          if(!this.$v.customer_detail.email.required){
            this.form_validation.email = 'Please input your email address'
          }else if(!this.$v.customer_detail.email.email){
            this.form_validation.email = 'Incorrect email'
          }else{
            this.form_validation.email = ''
          }
          this.scrollTo('note_section')
        }
        if(this.$v.customer_detail.phone_number.$invalid){
        	this.form_validation.phone_number = 'Please input your phone number'
          this.scrollTo('note_section')
        }

				if(this.general_data.payment_mode == 'PAY_IMMEDIATELY_OR_LATER' && !this.payment_mode_selected.id){
          this.payment_mode_valid = 'Please select payment time'
        }

        if(!this.$v.customer_detail.first_name.$invalid && !this.$v.customer_detail.email.$invalid && !this.$v.customer_detail.phone_number.$invalid && this.payment_mode_valid == ''){
        	return true
        }else{
          return false
        }
      },
			getApiParams(type='inquiry'){
				let params = {}
        if(type == 'inquiry'){
					params = {
						merchant_id: this.getMerchant.id,
						tx_merchant_pos:[],
						customer_detail: this.customer_detail,
						room_id: '',
						notes: this.notes,
						region: '',
						device: this.$getDeviceType(),
						promo_code: this.getVoucherOrder.promo_code,
						campaign_id: this.getUpsellRef.id != '' && this.getUpsellRef.type == 'CAMPAIGN' ? this.getUpsellRef.id : '',
						guest_journey_id: this.getUpsellRef.id != '' && this.getUpsellRef.type == 'GUEST_JOURNEY' ? this.getUpsellRef.id : ''
					}

					if(this.general_data.payment_mode != 'PAY_IMMEDIATELY_OR_LATER'){
            params.payment_mode = this.general_data.payment_mode
          }else{
            params.payment_mode = this.payment_mode_selected.id
          }

					for(let pos of this.getVoucherOrder.cart){
						let pos_product = {
							merchant_pos_id: pos.pos.id,
							products: []
						}
						for(let product of pos.product){
							if(product.is_variant){
								for(let variant of product.variant_list){
									let params_product = {
										id: variant.data.product_ga_pos_id,
										qty: variant.qty,
										notes: variant.notes
									}
									pos_product.products.push(params_product)
								}
							}else{
								let params_product = {
									id: product.data.product_ga_pos_id,
									qty: product.qty,
									notes: product.notes
								}
								pos_product.products.push(params_product)
							}
						}
						params.tx_merchant_pos.push(pos_product)
					}
				}else{
					let total_amount = Number(this.tx_inquiry.total_payment)+Number(this.getPaymentSurcharge)
	      	params = {
	      		merchant_id: this.getMerchant.id,
	      		tx_order_invoice_id: this.tx_inquiry.id,
	      		amount: Number(total_amount.toFixed(2)),
	      		customer_detail: {
	      			name: this.customer_detail.first_name,
	      			email: this.customer_detail.email,
	      			phone_number: this.customer_detail.phone_number
	      		},
	      		payment_details: {
	      			id: this.payment_method.selected.id,
	      			payment_method: this.payment_method.selected.payment_method,
	      			bank_name: this.payment_method.selected.bank_name,
	      			payment_channel: this.payment_method.selected.payment_channel
	      		}
	      	}
				}
				return params
			},
			submitForm(){
        return new Promise((success,fail)=>{
          if(this.cart_step == 1){
            let is_form_valid = this.validateForm()
            if(is_form_valid){
              this.pushApiInquiry().then(res=>{
                if(this.need_payment){
                  this.tx_inquiry = res.data
                  this.changeCartStep(2)
                }else{
                  this.setUpsellRef()
                  this.resetVoucherOrder()
                  this.$router.push({
	                  name: 'GroupVoucherBookingResult',
	                  params:{
	                    tx_order_id : res.data.id
	                  }
	                })
                }
                success()
              }).catch(err=>{
                this.error_push = err
                fail()
              })
            }else{
              fail("Incomplete Form")
            }
          }else{
            this.pushApiPayment().then(()=>{
              success()
            }).catch(err=>{
              this.error_push = err
              fail()
            })
          }
        })
      },
      pushApiInquiry(){
      	return new Promise((success,fail)=>{
      		this.error_push = ''
          let params = this.getApiParams()
					post("CORE_HOTEL","merchant-pos/multiple/tx-inquiry",params).then(response=>{
						let res = response.data
						if(res.success){
							success(res)
						}else{
							fail(res.message)
						}
					})
      	})
      },
      pushApiPayment(){
      	return new Promise((success,fail)=>{
					let params = this.getApiParams('payment')
	      	post("CORE_HOTEL","merchant-pos/tx-payment",params).then(response=>{
	      		let res = response.data
						if(res.success){
              if(this.payment_method.selected.bank_name == 'XENDIT' && this.payment_method.selected.payment_method == 'CREDIT_CARD'){
								this.result_tx_payment = res.payment
								this.result_tx_payment.tx_order_id_2 = res.tx_order_id 
	      				this.show_xendit_form = true
              }else{
                this.$proceedPayment('UPSELLING',this.tx_inquiry,res,this.payment_method.selected)
              }
							this.setUpsellRef()
              success(res)
            }else{
              fail(res.message)
            }
	      	})
      	})
      }
		}
	}
</script>


// WEBPACK FOOTER //
// src/pages/hotel/upselling/GroupVoucherCart.vue